import BaseWidget, {WidgetProps} from '../../../js/widget';

class SelfAssessmentLandingProps extends WidgetProps {
    selectors = {
        blocks: '.self-assessment-blocks .card__square__content',
        blockButton: '.btn',
    };
    elements = {
        blocks: [],
    };
}

export default class SelfAssessmentLanding extends BaseWidget {
    getPropsInstance(container) {
        return new SelfAssessmentLandingProps(container);
    }

    init() {
        this.setElements();
        this.addListeners();
    }

    setElements() {
        this.props.elements.blocks = [...this.props.container.querySelectorAll(this.props.selectors.blocks)];
        this.props.continueInitialization = !!this.props.elements.blocks.length;
    }

    addListeners() {
        if (!this.props.continueInitialization) {
            return;
        }
        this.props.elements.blocks.forEach(element => {
            element.addEventListener('click', e => e.preventDefault());
            const button = element.querySelector(this.props.selectors.blockButton);
            if (!button) {
                return;
            }
            button.addEventListener('click', this.navigate.bind(this, element));
        });
    }

    navigate(link, event) {
        event.preventDefault();
        location.href = link;
    }
}
